import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../../components/apiconfig/api-config';

const DeliveryOrderView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE_URL}/api/sales/delivery-order-get/${id}`, {
          method: 'GET',
          credentials: 'include',
        });
        if (!res.ok) throw new Error('Failed to fetch');
        const result = await res.json();
        setData(result.data);
      } catch (err) {
        setError('Failed to load data');
      }
      setLoading(false);
    };
    fetchData();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (error) return <div className="text-center text-red-600 py-8">{error}</div>;
  if (!data) return <div className="text-center py-8">No data found.</div>;

  // Use only DB data, no dummy values
  const staticLiftingParty = data.lifting_party || '';
  const staticQty = data.quantity_mt || '';
  const staticLocation = data.warehouse_location || '';
  const staticState = data.warehouse_state || '';
  const staticVessel = data.vessel_name || '';
  const staticWarehouse = data.warehouse_name || '';
  const staticCompany = data.buyer_name || '';
  const staticDONumber = data.do_number || '';
  const staticDate = data.do_date ? new Date(data.do_date).toLocaleDateString('en-GB') : '';

  return (
    <div className="max-w-3xl mx-auto bg-white p-6 border rounded shadow print:shadow-none print:border-0 print:p-4 print:max-w-full print:bg-white" style={{minHeight: '100vh'}}>
      <div className="flex justify-between items-center mb-4 print:hidden">
        <button onClick={() => navigate(-1)} className="text-[#15803d] hover:underline">Back</button>
        <button onClick={handlePrint} className="bg-[#15803d] hover:bg-[#166534] text-white px-3 py-1.5 rounded">Print</button>
      </div>
      
      {/* Header */}
      <div className="mb-5 print:mb-8 text-left">
        <h1 className="text-[16px] font-bold tracking-wide uppercase text-gray-900">Delivery Order Document</h1>
      </div>
      
      <div className="text-center mb-6 print:mb-9">
        <h2 className="text-[14px] font-semibold underline">Delivery Order</h2>
      </div>
      
      {/* Date and DO Number */}
      <div className="mb-5 print:mb-8 text-[13px]">
        <div>Date: {staticDate}</div>
        <div>Delivery Order No: {staticDONumber}</div>
      </div>
      
      {/* To Address */}
      <div className="mb-5 print:mb-8 text-[13px]">
        <div>To,</div>
        <div className="font-semibold">{staticCompany}</div>
        <div>(Fear Basin 2, 3, 5 & 6), Mumbai Port Trust Warehouse, 400010,</div>
        <div>Near Bandhar Bhawan Mazgaon.</div>
      </div>
      
      {/* Subject */}
      <div className="mb-5 print:mb-8 text-[13px]">
        <span className="font-semibold">Subject:</span> Delivery Order of the {data.commodity_name || ''} {staticQty} MT DO WILL.<br/>
        <span className="font-semibold">BE VALID TILL NEXT 10 DAYS</span>
      </div>
      
      {/* Body */}
      <div className="mb-5 print:mb-8 text-[13px]">
        <div>Dear Sir/Madam,</div>
        <div className="mt-4 print:mt-7">We hereby authorize <span className="font-semibold">{staticLiftingParty}</span> for {data.commodity_name || ''} {staticQty} MT lifting of the from {staticLocation} as per below details</div>
      </div>
      
      {/* Table */}
      <table className="w-full border text-[12px] mb-5 print:mb-8">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-2 py-1">Sr. No</th>
            <th className="border px-2 py-1">DO.NO</th>
            <th className="border px-2 py-1">Name of Company</th>
            <th className="border px-2 py-1">Name of the Vessel</th>
            <th className="border px-2 py-1">Name of Warehouse</th>
            <th className="border px-2 py-1">Location</th>
            <th className="border px-2 py-1">Qty In. MT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-2 py-1 text-center">1</td>
            <td className="border px-2 py-1">{staticDONumber}</td>
            <td className="border px-2 py-1">{staticCompany}</td>
            <td className="border px-2 py-1">{staticVessel || '-'}</td>
            <td className="border px-2 py-1">{staticWarehouse}</td>
            <td className="border px-2 py-1">{staticLocation}<br/>{staticState}</td>
            <td className="border px-2 py-1 text-right">{staticQty}</td>
          </tr>
        </tbody>
      </table>
      
      {/* Note */}
      <div className="mb-5 print:mb-8 text-[13px]">Kindly do the needful for lifting the material and share us the all-delivery details.</div>
      
      {/* Signature and Thanking you */}
      <div className="mb-5 print:mb-8 text-[13px]">
        <div>
          Thanking you<br/>
          For Authorized Signatory
        </div>
        {/* Signature if available */}
        {data.authority_signature && (
          <img 
            src={`${API_BASE_URL}/uploads/${data.authority_signature}`} 
            alt="Signature" 
            className="h-12 w-auto mt-5 print:mt-8"
            style={{height: '60px', maxWidth: '200px'}}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        )}
      </div>
      
      {/* Footer */}
      <div className="text-[12px] border-t pt-4 print:pt-7 text-center text-gray-500">
        This is an official computer-generated Delivery Order.
      </div>
    </div>
  );
};

export default DeliveryOrderView; 